<div class='run-grid-wrapper'>
  <ng-template #template let-anchor>
    <pre>{{ anchor.nativeElement.getAttribute("data-tooltip") }}</pre>
  </ng-template>
  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }
  @if (!this.nested) {
    <div class="runs-toolbar">
      <button type="button"
        class="app-pill-btn app-pill-btn--primary"
        (click)="getRuns(false, false, 0)">
        <i class="ms-Icon ms-Icon--Refresh flex-none" aria-hidden="true"></i>
        <span>Get Latest Runs</span>
      </button>
      <button type="button"
        class="app-pill-btn"
        (click)="refetchErrorRuns()">
        <i class="ms-Icon ms-Icon--Warning flex-none" aria-hidden="true"></i>
        <span>Refetch Error Runs</span>
      </button>
      <button type="button"
        class="app-pill-btn"
        [disabled]="!selection.length"
        (click)="onSelect({ dataItem: null, item: 'Resubmit' })">
        <i class="ms-Icon ms-Icon--Redo flex-none" aria-hidden="true"></i>
        <span>Resubmit{{ selection.length ? ' (' + selection.length + ')' : '' }}</span>
      </button>
      <button type="button"
        class="app-pill-btn"
        [disabled]="!selection.length"
        (click)="onSelect({ dataItem: null, item: 'Cancel' })">
        <i class="ms-Icon ms-Icon--Cancel flex-none" aria-hidden="true"></i>
        <span>Cancel{{ selection.length ? ' (' + selection.length + ')' : '' }}</span>
      </button>
      <button type="button"
        class="app-pill-btn"
        (click)="doExcel()">
        <i class="ms-Icon ms-Icon--ExcelDocument flex-none" aria-hidden="true"></i>
        <span>Export Excel</span>
      </button>
      <!-- "Get More Runs" dropdown — same CDK overlay pattern as the top-nav
      environment / user menus so the dropdown panel matches app-wide. -->
      <div class="runs-toolbar__dropdown-wrap">
        <button type="button"
          class="app-pill-btn"
          cdkOverlayOrigin
          #moreRunsOrigin="cdkOverlayOrigin"
          (click)="toggleMoreRunsMenu()">
          <i class="ms-Icon ms-Icon--More flex-none" aria-hidden="true"></i>
          <span>Get More Runs</span>
          <span class="app-dropdown-caret flex-none"
            [class.app-dropdown-caret--open]="moreRunsMenuOpen"
          aria-hidden="true"></span>
        </button>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="moreRunsOrigin"
          [cdkConnectedOverlayOpen]="moreRunsMenuOpen"
          [cdkConnectedOverlayHasBackdrop]="true"
          cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
          [cdkConnectedOverlayPositions]="dropdownPositionsLeft"
          [cdkConnectedOverlayOffsetY]="4"
          (backdropClick)="closeMoreRunsMenu()"
          (detach)="closeMoreRunsMenu()"
          >
          <div class="app-dropdown-panel">
            @for (p of pages; track p) {
              <button
                type="button"
                class="app-dropdown-item"
                (click)="onMoreRunsClick(p)">
                <i class="ms-Icon ms-Icon--Add" aria-hidden="true"></i>
                <span>{{ p.text }}</span>
              </button>
            }
          </div>
        </ng-template>
      </div>
      <flow-runs-sub class="runs-toolbar__sub"
      [text]="'Get All Runs (slow) is a subscription feature'"></flow-runs-sub>
      <span class="runs-toolbar__spacer"></span>
      <label class="runs-search">
        <i class="ms-Icon ms-Icon--Search flex-none" aria-hidden="true"></i>
        <input type="search"
          placeholder="Search runs…"
          [ngModel]="search"
          (ngModelChange)="onSearchChange($event)"
          aria-label="Search runs" />
          @if (search) {
            <button
              type="button"
              class="runs-search__clear"
              aria-label="Clear search"
              (click)="onSearchChange('')">
              <i class="ms-Icon ms-Icon--ChromeClose" aria-hidden="true"></i>
            </button>
          }
        </label>
      </div>
    }
    <kendo-grid class="flow-runs" [data]="(view$ | async)" [sort]="state.sort" [sortable]="true" [resizable]="true" [filter]="state.filter" [selectable]="true"
      filterable="menu" (dataStateChange)="dataStateChange($event)" [scrollable]="'virtual'" [kendoGridSelectBy]="'name'"
      [rowHeight]="35"
      [skip]="state.skip"
      [pageSize]="state.take"
      [(selectedKeys)]="selection" #rungrid>
      <kendo-grid-checkbox-column [width]="12" [style]="{'max-width':'12px', 'padding':'4px'}" [headerStyle]="{'max-width':'12px', 'padding':'4px'}">
        <ng-template kendoGridHeaderTemplate>
          <input type="checkbox"
            [checked]="isAllFilteredSelected()"
            [indeterminate]="isSomeFilteredSelected()"
            (change)="onSelectAllChange($event)"
            title="Select all" />
          </ng-template>
          <ng-template kendoGridFooterTemplate>
            @if (selection.length > 0) {
              <span title="{{ selection.length }} selected">{{ selection.length }}</span>
            }
          </ng-template>
        </kendo-grid-checkbox-column>
        <kendo-grid-column field="name" title="Name" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a href="{{this.apiRoot}}/manage/environments/{{dataItem.environment || this.flow.environment}}/flows/{{dataItem.flowName || this.flow.flowName}}/runs/{{dataItem.name}}"
              title="{{this.apiRoot}}/manage/environments/{{dataItem.environment || this.flow.environment}}/flows/{{dataItem.flowName || this.flow.flowName}}/runs/{{dataItem.name}}"
            target="_blank">{{dataItem.name}}</a>
          </ng-template>
          <ng-template kendoGridFooterTemplate let-column="column">
            <span title='Total'>{{(this.runs$|async)?.length}}&nbsp;</span>
            <span style="margin-left: 6px;">{{ this.flowManagementService.serviceStatus$ | async }}</span>
            @if (this.hasFilter$ | async) {
              <span title="click to clear filter" style="text-decoration: underline; cursor: pointer;" (click)="this.clearFilter()"><span class='ms-Icon ms-Icon--ClearFilter'></span> Results are filtered</span>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="status" title="Status" [width]="80" class="cell">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (test('succeed', dataItem.status)) {
              <span class='ms-Icon ms-Icon--SkypeCircleCheck' style='color:green;' title='Succeeded'></span>
            }
            @if ('Failed' == dataItem.status) {
              <span class='ms-Icon ms-Icon--SkypeCircleMinus' style='color:firebrick;' title='Failed'></span>
            }
            @if ('Test Failed' == dataItem.status) {
              <span class='ms-Icon ms-Icon--SkypeCircleMinus' style='color:gray;' title='Failed'></span>
            }
            @if (test('running',dataItem.status)) {
              <span class='ms-Icon ms-Icon--SkypeCircleClock' style='color:dodgerblue;' title='Running'></span>
            }
            @if (test('cancel',dataItem.status)) {
              <span class='ms-Icon ms-Icon--SkypeCircleMinus' style='color:gray' title='Cancelled'></span>
            }
            <span style='margin-left:5px;' title="{{ dataItem.status }}">{{dataItem.status}}</span>
          </ng-template>

        </kendo-grid-column>
        @if (this.flow == null) {
          <kendo-grid-column field="flowDisplayName" title="Flow" [width]="100" class="cell">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span title="{{ dataItem.flowDisplayName }}">{{dataItem.flowDisplayName}}</span>
            </ng-template>
          </kendo-grid-column>
        }
        <kendo-grid-column field="triggerName" title="Trigger" [width]="100" class="cell">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span title="{{ dataItem.triggerData  | json }}">{{dataItem.triggerName}}</span>
          </ng-template>
        </kendo-grid-column>
        @if (this.flow) {
          <kendo-grid-column field="triggerValue" title="Trigger ID" [width]="100" class="cell">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if (this.flow?.triggerIcon) {
                <img [src]='this.getSafeUrl(this.flow?.triggerIcon)' style='width:20px; height:20px; vertical-align:middle;' />
                }&nbsp;
                @if (dataItem.error) {
                  <span class="k-icon k-i-warning" title="{{ dataItem.error | json }}"></span>
                }
                <span title="{{ dataItem.triggerData  | json }}">{{dataItem.triggerValue}}</span>
              </ng-template>
            </kendo-grid-column>
          }
          @if (this.flow) {
            <kendo-grid-column field="triggerText" title="Trigger Text" [width]="150" class="cell">
              <ng-template kendoGridCellTemplate let-dataItem>
                @if (this.flow?.triggerIcon) {
                  <img [src]='this.getSafeUrl(this.flow?.triggerIcon)' style='width:20px; height:20px; vertical-align:middle;' />
                  }&nbsp;
                  <span title="{{ dataItem.triggerData  | json }}">{{dataItem.triggerText}}</span>
                </ng-template>
              </kendo-grid-column>
            }
            <kendo-grid-column field="startTime" title="Start" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="80" class="cell">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span title="{{dataItem.startTime|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.startTime|date:'y-MM-dd HH:mm'}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="endTime" title="End" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="80" class="cell">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span title="{{dataItem.endTime|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.endTime|date:'y-MM-dd HH:mm'}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="duration" title="Duration" type="number" format="{0:g}" [width]="100" class="cell">
              <ng-template kendoGridCellTemplate let-dataItem>
                @if (dataItem.endTime) {
                  <span>{{dataItem.duration}} ({{dataItem.durationString}})</span>
                }
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel fileName="runs.xlsx" [fetchData]="allData">
              <kendo-excelexport-column field="name" title="Name"></kendo-excelexport-column>
              <kendo-excelexport-column field="status" title="Status"></kendo-excelexport-column>
              <kendo-excelexport-column field="triggerName" title="Trigger"></kendo-excelexport-column>
              <kendo-excelexport-column field="triggerValue" title="Trigger ID"></kendo-excelexport-column>
              <kendo-excelexport-column field="triggerText" title="Trigger Text"></kendo-excelexport-column>
              <kendo-excelexport-column field="startTime" title="Start"></kendo-excelexport-column>
              <kendo-excelexport-column field="endTime" title="End"></kendo-excelexport-column>
              <kendo-excelexport-column field="duration" title="Duration"></kendo-excelexport-column>
              <kendo-excelexport-column field="runUrl" title="URL"></kendo-excelexport-column>
              <kendo-excelexport-column field="triggerDataValue" title="Trigger Data"></kendo-excelexport-column>
              <kendo-excelexport-column field="error" title="Error"></kendo-excelexport-column>
            </kendo-grid-excel>
          </kendo-grid>
          @if ((this.loading$ | async)) {
            <div class="loading">
              <div class="k-i-loading"></div>
            </div>
          }
          <grid-context-menu [for]="rungrid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" [admin]="admin" (select)="onSelect($event)">
          </grid-context-menu>

          <ng-template #confirmTemplate>
            <p style="margin: 0 0 16px;">{{ confirmMessage }}</p>
            <div style="display: flex; gap: 8px; justify-content: flex-end;">
              <button type="button" class="app-pill-btn app-pill-btn--primary" (click)="resolveConfirm(true)">Yes</button>
              <button type="button" class="app-pill-btn" (click)="resolveConfirm(false)">No</button>
            </div>
          </ng-template>
        </div>
